import { useEffect } from 'react'
import { useChallenge } from '../../hooks/challenge/useChallenge'
import { useChallengeId } from '../../hooks/challenge/useChallengeId'
import { useChallengeTheme } from '../../hooks/challenge/useChallengeTheme'

export default function ChallengeThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = useChallengeTheme()
  const challengeId = useChallengeId()
  const { data: challenge } = useChallenge(challengeId)

  useEffect(() => {
    document.documentElement.dataset.theme = theme
  }, [theme])

  useEffect(() => {
    const root = document.documentElement
    if (challenge?.primaryColor) {
      root.style.setProperty('--brand-primary', challenge.primaryColor)
      root.style.setProperty('--orange', challenge.primaryColor)
      root.style.setProperty('--orange-ink', challenge.primaryColor)
    } else {
      root.style.removeProperty('--brand-primary')
      root.style.removeProperty('--orange')
      root.style.removeProperty('--orange-ink')
    }
    if (challenge?.secondaryColor) {
      root.style.setProperty('--brand-secondary', challenge.secondaryColor)
      root.style.setProperty('--blue', challenge.secondaryColor)
      root.style.setProperty('--blue-ink', challenge.secondaryColor)
    } else {
      root.style.removeProperty('--brand-secondary')
      root.style.removeProperty('--blue')
      root.style.removeProperty('--blue-ink')
    }

    if (challenge?.name) {
      document.title = challenge.name
    }

    const themeColorMeta = document.querySelector('meta[name="theme-color"]')
    if (themeColorMeta && challenge?.primaryColor) {
      themeColorMeta.setAttribute('content', challenge.primaryColor)
    }
  }, [challenge?.primaryColor, challenge?.secondaryColor, challenge?.name])

  return <>{children}</>
}
